import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const InternalAlertsAdmin = () =>
  import('@/pages/partnerGuardianAndAlerts/alert-admin/AdminAlerts.vue');
const FleetHpFormDataList = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-hp-form-data/FleetHpFormDataList.vue');
const FleetHpFormDataGet = () =>
  import('@/pages/ryd-fleet-operations/acquisition-funnel/fleet-hp-form-data/FleetHpFormDataGet.vue');

export const internalOperationsRoutes: AppRouteRecordRaw[] = [
  {
    path: '/internal-operations',
    component: Body,
    meta: {
      breadcrumb: 'Internal Operations',
    },
    children: [
      {
        path: 'alerts',
        name: 'InternalAlertsAdmin',
        component: InternalAlertsAdmin,
        meta: {
          title: 'Internal - Alert Management | ryd Portal',
          breadcrumb: 'Alert Management',
          requiresAuth: true,
          requiredUserGroup: ['ryd22'],
          requiredPartnerTypes: ['RYD_INTERNAL'],
        },
      },
      {
        path: 'fleet-hp-form-data',
        name: 'fleetHpFormData',
        component: FleetHpFormDataList,
        meta: {
          title: 'Fleet HP Form Submissions | ryd Portal',
          breadcrumb: 'Homepage Fleet Form Data',
        },
      },
      {
        path: 'fleet-hp-form-data-item',
        name: 'SubmissionDetails',
        component: FleetHpFormDataGet,
        meta: {
          title: 'Fleet HP Form Submission | ryd Portal',
          breadcrumb: 'Submission Details',
        },
      },
      {
        path: 'fleet/fleet-hp-form',
        name: 'FleetHpFormV2List',
        redirect: '/fleet-operations/fleet-hp-form',
      },
      {
        path: 'fleet/fleet-hp-form/details/:id',
        name: 'FleetHpFormV2Details',
        redirect: (to) => `/fleet-operations/fleet-hp-form/details/${to.params.id}`,
      },
      {
        path: 'fleet/fleet-marketing-funnel-sessions',
        name: 'FleetMarketingFunnelSessionsList',
        redirect: '/fleet-operations/fleet-marketing-funnel-sessions',
      },
      {
        path: 'fleet/fleet-marketing-funnel-sessions/:sessionId',
        name: 'FleetMarketingFunnelSessionDetail',
        redirect: (to) =>
          `/fleet-operations/fleet-marketing-funnel-sessions/${to.params.sessionId}`,
      },
      {
        path: 'fleet-temp-pws',
        name: 'FleetTempPws',
        redirect: '/fleet-operations/fleet-temp-pws',
      },
      {
        path: 'fleet-virtual-emails',
        name: 'FleetVirtualEmails',
        redirect: '/fleet-operations/fleet-virtual-emails',
      },
      {
        path: 'fleet-virtual-emails/:id',
        name: 'FleetVirtualEmailDetail',
        redirect: (to) => `/fleet-operations/fleet-virtual-emails/${to.params.id}`,
      },
      { path: 'list-price', redirect: '/backoffice/list-price' },
      {
        path: 'list-price/partner-incoming-emails',
        redirect: '/backoffice/list-price/partner-incoming-emails',
      },
      {
        path: 'list-price/partner-incoming-emails/:id',
        redirect: (to) => `/backoffice/list-price/partner-incoming-emails/${to.params.id}`,
      },
      {
        path: 'list-price/contact-management',
        redirect: '/backoffice/list-price/contact-management',
      },
      { path: 'list-price/price-adjustment', redirect: '/backoffice/list-price/price-adjustment' },
      { path: 'list-price/price-history', redirect: '/backoffice/list-price/price-history' },
      { path: 'list-price/partner-discount', redirect: '/backoffice/list-price/partner-discount' },
      { path: 'api-partner-discount', redirect: '/backoffice/api-partner-discount' },
      { path: 'list-price/email-preview', redirect: '/backoffice/list-price/email-preview' },
      {
        path: 'administration/metadata-sync',
        redirect: '/backoffice/administration/metadata-sync',
      },
      {
        path: 'administration/cloudflare-firebase-remote-config',
        redirect: '/backoffice/administration/cloudflare-firebase-remote-config',
      },
      {
        path: 'administration/token-management',
        redirect: '/backoffice/administration/token-management',
      },
      { path: 'email-domains', redirect: '/backoffice/email-domains' },
      { path: 'email-domains/add', redirect: '/backoffice/email-domains/add' },
      {
        path: 'email-domains/edit/:id',
        redirect: (to) => `/backoffice/email-domains/edit/${to.params.id}`,
      },
      { path: 'invoicing/failed-requests', redirect: '/accounting/invoicing/failed-requests' },
      {
        path: 'invoicing/data-consistency-check',
        redirect: '/accounting/invoicing/data-consistency-check',
      },
      {
        path: 'invoice/invoice-cancellation',
        redirect: '/accounting/invoicing/invoice-cancellation',
      },
      {
        path: 'invoice/invoice-modification',
        redirect: '/accounting/invoicing/invoice-modification',
      },
    ],
  },
];
